import dayjs from 'dayjs';
import { useLang } from 'hooks/useLang';
import { useState, useEffect } from 'react';

const days = Array.from({ length: 31 }, (_, i) => i + 1);
const years = Array.from({ length: 80 }, (_, i) => new Date().getFullYear() - i);
const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

export default function DateOfBirthInput({ onChange, error, value }) {
    const [day, setDay] = useState(value ? value?.day : "");
    const [month, setMonth] = useState(value ? value?.month : "");
    const [year, setYear] = useState(value ? value?.year : "");

    const { t } = useLang();


    useEffect(() => {
        if (day && month && year) {
            const formattedDate = dayjs(`${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`).format('YYYY-MM-DD');
            if (onChange) onChange(formattedDate);

        }
    }, [day, month, year]);



    return (
        <div className='max-w-md mx-auto'>
            <div className='grid grid-cols-3 gap-2'>
                <select
                    className={`border ${error ? "border-red-400" : day !== "" ? "border-[#7B91EF]" : "border-[#78728e]"
                        } rounded-md transition-all bg-opacity-40 dark:bg-[#1d1544] h-[40px] focus:outline-none`}
                    value={day}
                    onChange={(e) => setDay(e.target.value)}
                >
                    <option value="" selected hidden>{t("dayName")}</option>
                    {days.map((d) => (
                        <option key={d} value={d}>
                            {d}
                        </option>
                    ))}
                </select>

                <select
                    className={`border ${error ? "border-red-400" : month !== "" ? "border-[#7B91EF]" : "border-[#78728e]"
                        } rounded-md transition-all bg-opacity-40 dark:bg-[#1d1544] h-[40px] focus:outline-none`}
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                >
                    <option value="" selected hidden>{t("monthName")}</option>
                    {months.map((m, index) => (
                        <option key={m} value={index + 1}>{t(`${m}`)}</option>
                    ))}
                </select>

                <select
                    className={`border ${error ? "border-red-400" : year !== "" ? "border-[#7B91EF]" : "border-[#78728e]"
                        } rounded-md transition-all bg-opacity-40 dark:bg-[#1d1544] h-[40px] focus:outline-none`}
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                >
                    <option value="" selected hidden>{t("yearName")}</option>

                    {years.filter((y) => y <= new Date().getFullYear() - 15).map((y) => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>
                {error && (
                    <span className={`pt-1 text-xs text-red-500 dark:text-red-400 errorStyle animate-shake`}>
                        {t(error)}
                    </span>
                )}
            </div>

        </div>
    );
}
